import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ActivatedRoute } from '@angular/router';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: false
    })
  ],
  exports: [
    TranslateModule
  ],
  providers: [TranslateService]
})
export class TranslateSharedModule {

  constructor(private translate: TranslateService, private router: ActivatedRoute) {
    const getLanguage = localStorage.getItem('language');
    console.log('GET LANGUAGE ->', getLanguage);
    if (getLanguage) {
      var language = (getLanguage && getLanguage != 'undefined' && getLanguage != '') ? getLanguage : 'pt-br';
      translate.setDefaultLang(language);
      translate.use(language);
    } else {
      let timer = setInterval(() => {
        if (!getLanguage) {
          this.router.queryParams.subscribe(param => {
            if (param.lang != undefined) {
              console.log('Params ->', param.lang);
              localStorage.setItem('language', param.lang);
            }
            else {
              localStorage.setItem('language', 'pt-br');
            }
          })
          clearInterval(timer);
        }
        console.log('GET LANGUAGE 2 ->', getLanguage);

      }, 40)
    }


  }

  showTranslator(txt) {
    return this.translate.get(txt).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/translate/translate.module.ts